import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//helpers:
import { getData } from '../../dataLib';

//component ui:
import DatePicker from '../../components/utils/DatePicker';
//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';

import NeuriteGrid from '../../components/neurite_grid';
//actions:
import { openDialog, hideDialog } from '../../actions';

const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    bottomBtn: {
        direction: 'rtl',
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    containerControls: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
});

class ListaMovimientos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            movimientos: [],
            fIni: new Date(Date.UTC(2019, 0, 1)).toJSON().slice(0, 10),
            fEnd: new Date().toJSON().slice(0, 10),
            showSpinner: true,
        };
    }

    componentDidMount = () => {
        this.getMovimientos();
    };

    messageDialog = msg => {
        this.props.openDialog(
            'SimpleMessage',
            {
                message: msg,
            },
            uuidv4(),
            false,
            'sm',
        );
    };

    getMovimientos = () => {
        let lectURL =
            'VDAMovEc?zona_id=' +
            this.props.zona_id +
            '&ini_date=' +
            this.state.fIni +
            '&end_date=' +
            this.state.fEnd;

        getData(
            lectURL,
            response => {
                this.setState({
                    ...this.state,
                    movimientos: response.data,
                    showSpinner: false,
                });
            },
            error => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'error obteniendo movimientos',
                    },
                    'error-obtener-movimientos',
                    false,
                    'sm',
                );
            },
            this.props.user,
        );
    };

    handleDateIniChange = event => {
        if (this.state.fEnd < event) {
            this.props.openDialog(
                'SimpleMessage',
                {
                    message:
                        'la fecha inicial no puede ser posterior a la fecha final',
                },
                'error-fecha-inicio-movimientos',
                false,
                'sm',
            );
            return;
        }
        this.setState({ ...this.state, fIni: event });
    };

    handleDateEndChange = event => {
        if (this.state.fIni > event) {
            this.props.openDialog(
                'SimpleMessage',
                {
                    message:
                        'la fecha final no puede ser anterior a la fecha inicial',
                },
                'error-fecha-final-movimientos',
                false,
                'sm',
            );
            return;
        }

        this.setState({ ...this.state, fEnd: event });
    };

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Typography
                    variant="h6"
                    className={classes.title}
                    color={'primary'}
                >
                    Movimientos
                </Typography>

                {!this.props.showSpinner ? (
                    <div>
                        <div className={classes.containerControls}>
                            <FormControl className={classes.formControl}>
                                {/* <TextField
                                    id={'fIni'}
                                    label={'Inicio'}
                                    placeholder={'Inicio'}
                                    type="date2"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    className={classes.textField}
                                    margin="normal"
                                    autoFocus
                                    value={this.state.fIni}
                                    onChange={(event) => this.handleDateIniChange(event, 'fIni')}
                                /> */}
                                <DatePicker
                                    label={'Inicio'}
                                    className={classes.textField}
                                    value={this.state.fIni}
                                    onChange={event => {
                                        if (event && !isNaN(event)) {
                                            const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                            this.handleDateIniChange(d.toISOString().slice(0, 10), 'fIni')
                                        }
                                    }}
                                />
                            </FormControl>
                            <FormControl className={classes.formControl}>
                                {/* <TextField
                  id={"fEnd"}
                  label={"Fin"}
                  placeholder={"Fin"}
                  type="date2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  className={classes.textField}
                  margin="normal"
                  autoFocus
                  value={this.state.fEnd}
                  onChange={event => this.handleDateEndChange(event, "fEnd")}
                /> */}
                                <DatePicker
                                    label={'Fin'}
                                    className={classes.textField}
                                    value={this.state.fEnd}
                                    onChange={event => {
                                        if (event && !isNaN(event)) {
                                            const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                            this.handleDateEndChange(d.toISOString().slice(0, 10), 'fEnd')
                                        }
                                    }}
                                />
                            </FormControl>

                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                onClick={() => {
                                    this.getMovimientos();
                                }}
                            >
                                Cargar movimientos
                            </Button>
                        </div>

                        <NeuriteGrid
                            id="l_m"
                            columns={[
                                {
                                    key: 'fecha',
                                    name: 'Fecha',
                                    editable: false,
                                    dragable: false,
                                    type: 'date',
                                    width: 80,
                                },
                                {
                                    key: 'isMovCaja',
                                    name: 'isMovCaja',
                                    editable: false,
                                    dragable: false,
                                    type: 'bool',
                                    width: 80,
                                },
                                {
                                    key: 'descr',
                                    name: 'Descripción',
                                    editable: false,
                                    dragable: false,
                                    width: 200,
                                },
                                {
                                    key: 'importe',
                                    name: 'Importe',
                                    editable: false,
                                    dragable: false,
                                    type: 'float',
                                    width: 100,
                                },
                            ]}
                            rows={this.state.movimientos}
                            height={400}
                            buttonEdit={false}
                            buttonDelete={false}
                            enableSelection={false}
                            enableFilter={true}
                        />
                    </div>
                ) : (
                        <div className={classes.spinnerContainer}>
                            {' '}
                            <CircularProgress
                                className={classes.spinner}
                                color="primary"
                            />{' '}
                        </div>
                    )}

                <div className={classes.bottomBtn}>
                    <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={() => {
                            this.props.hideDialog();
                        }}
                    >
                        Cerrar
                    </Button>
                </div>
            </div>
        );
    }
}

ListaMovimientos.propTypes = {
    //dispatch
    hideDialog: PropTypes.func.isRequired,
    zona_id: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            openDialog,
            hideDialog,
        },
        dispatch,
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(ListaMovimientos));
